import { cn } from '@/lib/cn';
import { tStatic } from '@/i18n';

/**
 * Indeterminate ring. Uses currentColor so it inherits whatever control it
 * sits inside, and keeps a single rotation under reduced-motion via CSS.
 */
export function Spinner({ className, label }: { className?: string; label?: string }) {
  return (
    <span role="status" aria-live="polite" className={cn('inline-flex', className)}>
      <svg viewBox="0 0 24 24" fill="none" className="size-full animate-spin" aria-hidden="true">
        <circle cx="12" cy="12" r="9" stroke="currentColor" strokeOpacity="0.22" strokeWidth="2.5" />
        <path
          d="M21 12a9 9 0 0 0-9-9"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
        />
      </svg>
      <span className="sr-only">{label ?? tStatic('common.loading')}</span>
    </span>
  );
}
